export enum Operation {
  UPDATE = "UPDATE",
  CREATE = "CREATE",
  DELETE = "DELETE",
  VIEW = "VIEW",
  NONE = "NONE",
  CLEAR = "CLEAR",
  CLOSE = "CLOSE",
  PRIMARY = "PRIMARY",
}

export enum LicenseTypes {
  ADMIN = "ADMIN",
  ASSET = "ASSET",
  CUSTOMER = "CUSTOMER",
  COMPANY = "COMPANY",
  SUBSIDIARY = "SUBSIDIARY",
  NONE = "NONE",
  CUSTOMER_USERS = "CUSTOMER_USERS",
  CONFIG = "CONFIGS",
  DASHBOARD = "DASHBOARD",
  TECHNICIAN_DASHBOARD = "TECHNICIAN_DASHBOARD",
}

export enum TableHeaders {
  ACTION = "Actions",
  SLNO = "Sl",
}

export enum MasterPages {
  ITEM_GROUP = "Item Group",
  CATEGORY = "Category",
  MANUFACTURER = "Manufacturer",
  UNIT_OF_MEASUREMENT = "Unit of Measurement",
}

export enum PageFor {
  MODAL = "Modal",
  GENERAL = "General",
  VIEW = "View",
}

export enum ActiveType {
  CURR = "CURR",
}

export enum empType {
  SYS_ADMIN = "SYS_ADMIN",
  JCP = "JCP",
  ACP = "ACP",
  DCP = "DCP",
  HC = "HC",
  PC = "PC",
  WHC = "WHC",
  WPC = "WPC",
  PSI = "PSI",
  ASI = "ASI",
  WPSI = "WPSI",
  WASI = "WASI",
  VENDOR_MANAGER = "VENDOR_MANAGER",
  TECHNICIAN = "TECHNICIAN",
  HELP_DESK = "HELP_DESK",
  PMU = "PMU",
  NONE = "",
}

export enum YesNo {
  YES = "Yes",
  NO = "No",
}

export enum MaterialRequestStatus {
  PENDING = "Pending",
  APPROVED = "Approved",
  REJECTED = "Rejected",
  INPROGRESS = "In Progress",
  ALL = "All",
}

export enum SubsidiaryPriority {
  LOW = "Low",
  HIGH = "High",
  MiD = "Mid",
}
export enum TagNames {
  INPUT = "input",
  TEXTAREA = "TEXTAREA",
}

export enum TransStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

export enum AcceptReject {
  ACCEPT = "ACCEPT",
  REJECT = "REJECT",
}

export enum PriorityEnum {
  CRITICAL = "CRITICAL",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
  MAJOR = "MAJOR",
  ALL = "ALL",
}

export enum FromStatus {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum PurchaseOrderTypes {
  MRFtoPo = "MRFtoPO",
  RFQToPO = "RFQtoPO",
}

export const enum itemConfigVariables {
  isConsumable = "ITEM_CONSUMABLE",
  imageNeeded = "ITEM_IMAGE_NEEDED",
  trackInstallation = "ITEM_TRACK_INSTALLATION",
  trackInsurance = "ITEM_TRACK_INSURANCE",
  trackMaintenance = "ITEM_TRACK_MAINTENANCE",
  trackSerial = "ITEM_TRACK_SERIAL",
  trackWarranty = "ITEM_TRACK_WARRANTY",
  isPerishable = "ITEM_PERISHABLE",
  trackAmc = "ITEM_TRACK_AMC",
  trackBatch = "ITEM_TRACK_BATCH",
  trackExpiry = "ITEM_TRACK_EXPIRY",
  trackGeoLocation = "ITEM_TRACK_GEO_LOCATION",
}
export enum ItemDetailsQueryType {
  ALL = "ALL",
  DETAILS_BY_ITEM_ID = "DETAILS_BY_ITEM_ID",
  GEO_ENABLED = "GEO_ENABLED",
  TO_CREATE_MODULE = "TO_CREATE_MODULE",
}

export enum MapPageFor {
  TICKET = "TICKET",
  VIEW = "VIEW",
  MODAL = "MODAL",
}

export enum ConfigLabels {
  COMPANY_LABEL = "COMPANY_LABEL",
  SUBSIDIARY_LABEL = "SUBSIDIARY_LABEL",
  LDGR_LABEL = "LDGR_LABEL",
  ITEM_LABEL = "ITEM_LABEL",
  SUBSIDIARY_SITE_LABEL = "SUBSIDIARY_SITE_LABEL",
  JUNCTION_LABEL = "JUNCTION_LABEL",
}
export enum SeparatorTypes {
  SLASH = "/",
  SPACE = "  ",
  HYPHEN = "-",
}

export enum TimeZone {
  Asia_Kolkata = "Asia/Kolkata",
}

export enum JunctionStatus {
  NOT_WORKING = "NOT_WORKING",
  COMMISSIONED = "COMMISSIONED",
  INSTALLED = "INSTALLED",
  WORK_IN_PROGRESS = "WORK_IN_PROGRESS",
  PLANNED = "PLANNED",
  SHIFTING = "SHIFTING",
  DECOMMISSIONED = "DECOMMISSIONED",
}

export enum ExportTypes {
  EXCEL = "EXCEL",
  PDF = "PDF",
}

export enum AttendanceTypes {
  Present = "P",
  Absent = "A",
}

export enum DataTypes {
  TEXT = "Text",
  NUMBER = "Number",
  ALPHANUMERIC = "AlphaNumeric / Varchar",
  FLOAT = "Float",
  BOOLEAN = "BOOLEAN",
  DATE = "DATE",
}

export enum PageFrom {
  DASHBOARD = "dashboard",
  WORKPROGRESS = "workprogress",
  REPORTS = "reports",
  SITE = "site",
  ADDSITE = "addsite",
}

export enum PageFromForTickets {
  DASHBOARD = "dashboard",
  TICKETS_PAGE = "TICKETS_PAGE",
}

export enum PageFromJunction {
  GEO_ENABLED = "GEO_ENABLED",
  JUNCTION_ITEM_REPALCE_PAGE = "JUNCTION_ITEM_REPALCE_PAGE",
  JUNTION_ITEM_COUNT = "JUNTION_ITEM_COUNT",
  DASH_BOARD = "DASH_BOARD"
}

export enum EnvAccessType {
  DEV = "DEV",
  ARCADIS_PROD = "ARCADIS_PROD",
}
